export default [{
  name: 'breakdown',
  path: 'breakdown',
  component: () => import('./Index.vue'),
  meta: {
    title: '故障信息及处理'
  }
}]



// WEBPACK FOOTER //
// ./src/router/breakdown_term/index.js